import React, { useEffect, useCallback } from "react";
import { Container, Table, Col, Button } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchSimulationCOnly } from "../../Redux/simulationCReduce";


function DetailSimulationC({ client }) {
    const dispatch = useDispatch();
    const navigate = useHistory();
    const location = useParams();
    const [entities, setEntities] = React.useState([]);
    const [tete, setEntitieTete] = React.useState([]);
    const [loader, setLoader] = React.useState(true);

    const getSimulationC = useCallback(
        async () => {
            var PrixProd = await dispatch(fetchSimulationCOnly({ id: location.id }));
            var findSimulationC = await PrixProd.payload.arrayPrixProd;
            var tableRows = findSimulationC.map((element, key) => (
                <tr key={"pp" + key}>
                    <td>{element.produit}</td>
                    <td>{element.client}</td>
                    <td>{element.quota}</td>
                    <td>{element.quantite}</td>
                </tr>
            ));
            setEntities(tableRows);
            setLoader(false)
        },
        [dispatch, location.id]
    );


    const getentete = useCallback(async () => {
        const entete = await dispatch(fetchSimulationCOnly({ id: location.id }));
        const data = entete.payload.entete;

        const table = (
            <Table bordered hover style={{ textAlign: "center" }}>
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Date1</th>
                        <th>Date2</th>
                        <th>Année</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{data.type}</td>
                        <td>{data.date1}</td>
                        <td>{data.date2}</td>
                        <td>{data.annee}</td>
                    </tr>
                </tbody>
            </Table>
        );

        setEntitieTete(table);
    }, [dispatch, location.id]);

    useEffect(() => {
        getSimulationC();
        getentete();
    }, [getSimulationC, getentete]);



    function listepp() {
        navigate.push(client + "/listSimulationC");
    }

    return (
        <>


            <Container fluid>

                <Col md="12">
                    <Button
                        id="saveBL"
                        className="btn-wd btn-outline mr-1 float-left"
                        type="button"
                        variant="info"
                        onClick={listepp}
                    >
                        <span className="btn-label">
                            <i className="fas fa-list"></i>
                        </span>
                        Retour à la liste
                    </Button>
                </Col>
                {loader ? (
                    <div className="loader-container">
                        <div className="loader"></div>
                    </div>
                ) : (
                    <div>
                        {tete}

                        < hr style={{ borderTop: "4px solid black" }}></hr>

                        <Table bordered hover>
                            <thead className="entete_detail">
                                <tr>
                                    <th>Produit</th>
                                    <th>Grossiste</th>
                                    <th>Quota</th>
                                    <th>Quantité</th>
                                </tr>
                            </thead>
                            <tbody>{entities}</tbody>
                        </Table>
                    </div>
                )}
            </Container >
        </>
    );
}

export default DetailSimulationC;
